import React from 'react';
import { MapPin, Calendar, Users, Clock, Mail, Phone } from 'lucide-react';
import { eventInfo } from '../data/mock';

const EventInfo = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Informace o akci
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Kompletní cateringové řešení pro váš firemní Family Day
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Left Column - Event Details */}
            <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-3xl p-8 shadow-lg border border-cyan-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Detaily akce</h3>
              <div className="space-y-5">
                <div className="flex items-start space-x-4">
                  <div className="bg-cyan-600 rounded-lg p-3 text-white">
                    <Calendar className="w-6 h-6" />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 font-medium">Datum</div>
                    <div className="text-lg font-semibold text-gray-900">{eventInfo.date}</div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="bg-cyan-600 rounded-lg p-3 text-white">
                    <Clock className="w-6 h-6" />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 font-medium">Čas</div>
                    <div className="text-lg font-semibold text-gray-900">{eventInfo.time}</div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="bg-cyan-600 rounded-lg p-3 text-white">
                    <MapPin className="w-6 h-6" />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 font-medium">Místo konání</div>
                    <div className="text-lg font-semibold text-gray-900">{eventInfo.location}</div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="bg-cyan-600 rounded-lg p-3 text-white">
                    <Users className="w-6 h-6" />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 font-medium">Počet hostů</div>
                    <div className="text-lg font-semibold text-gray-900">Cca {eventInfo.expectedGuests} osob</div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Right Column - Contact Person */}
            <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-3xl p-8 shadow-lg border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Kontaktní osoba - Wanzl</h3>
              <div className="space-y-5">
                <div className="flex items-center space-x-4">
                  <div className="bg-gray-700 rounded-full w-16 h-16 flex items-center justify-center text-white text-2xl font-bold">
                    {eventInfo.contactPerson.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <div>
                    <div className="text-xl font-bold text-gray-900">{eventInfo.contactPerson.name}</div>
                    <div className="text-sm text-gray-600">{eventInfo.contactPerson.position}</div>
                  </div>
                </div>
                
                <div className="flex items-center space-x-3 p-4 bg-white rounded-xl border border-gray-200">
                  <Phone className="w-5 h-5 text-cyan-600" />
                  <a href={`tel:${eventInfo.contactPerson.phone}`} className="text-gray-900 font-medium hover:text-cyan-600 transition-colors">
                    {eventInfo.contactPerson.phone}
                  </a>
                </div>
                
                <div className="flex items-center space-x-3 p-4 bg-white rounded-xl border border-gray-200">
                  <Mail className="w-5 h-5 text-cyan-600" />
                  <a href={`mailto:${eventInfo.contactPerson.email}`} className="text-gray-900 font-medium hover:text-cyan-600 transition-colors break-all">
                    {eventInfo.contactPerson.email}
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          {/* Requirements Summary */}
          <div className="mt-12 bg-gradient-to-r from-cyan-600 to-blue-600 rounded-3xl p-8 text-white shadow-xl">
            <h3 className="text-2xl font-bold mb-4">Požadavky na catering</h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold mb-2">1x</div>
                <div className="text-cyan-100">Hlavní jídlo na osobu</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold mb-2">1x</div>
                <div className="text-cyan-100">Párek v rohlíku</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold mb-2">1x</div>
                <div className="text-cyan-100">Zmrzlina</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold mb-2">1x</div>
                <div className="text-cyan-100">Teplý nápoj</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold mb-2">2x</div>
                <div className="text-cyan-100">Studený nápoj</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold mb-2">Stravenky</div>
                <div className="text-cyan-100">Průběžný výdej</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventInfo;
